import React, { useState, useEffect, useContext } from "react";
import { getCurrentDate } from "../../../configs/helpers";
import { EditOrderPurchaseReceivedList } from "../fragments.buys/EditOrderPurchaseReceivedList";
import { EditOrderPurchaseReceivedForm } from "../fragments.buys/EditOrderPurchaseReceivedForm";

import { useParams } from "react-router";
import { fetchedOrderPurchaseByID } from "../../../apis/apis.logistics/apisProduct";
const initialOrderState = {
  operationID: 0,
  operationDate: getCurrentDate("-"),
  operationDocumentNumber: "",
  operationCorrelative: 0,
  operationCode: "",
  percentageIgv: 18,
  conditionIgv: "02",
  operationNumberItems: 0,
  operationItems: [],
  operationStatus: "01",
  operationStatusDisplay: "PENDIENTE",

  operationActionID: "NA",
  operationTypeID: "08",
  operationDocumentTypeID: "03",
  operationAmountBase: "",
  operationAmountIgv: "",
  operationAmountTotal: "",
  supplierDocumentType: "06",
  supplierFirstSurname: "",
  supplierFiscalAddress: "",
  supplierID: "0",
  supplierSecondSurname: "",
  supplierDocumentNumber: "",
  supplierName: "",
  warehouseID: 0,
  warehouseName: "",
  warehouseCategory: "",
  userID: 0,
};

export function EditOrderPurchaseReceivedPage() {
    let { id } = useParams();
    const [order, setOrder] = useState(initialOrderState);
  
    const getOrderPurchase = async () => {
      try {
        const response = await fetchedOrderPurchaseByID({ operationID: id });
        setOrder(response);        
        //return response;
      } catch (error) {
        throw error;
      }
    };
  
    useEffect(() => {
      getOrderPurchase()
    }, []);
  

    return (
      <>
        <section className="mb-6">
          <div className="max-w-full px-4">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                EDICIÓN DE COMPRA RECEPCIONADA
              </h1>
              <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                <span>Orden de Compras</span>
                <span className="text-gray-400">/</span>
                <span className="font-medium text-gray-900 dark:text-white">{id}</span>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="max-w-full px-4">
            <EditOrderPurchaseReceivedForm order={order} setOrder={setOrder} initialOrderState={initialOrderState} />
            <EditOrderPurchaseReceivedList order={order} setOrder={setOrder} initialOrderState={initialOrderState} />
          </div>
        </section>
      </>
    );
}
